import { handleActions } from 'redux-actions';
import { SET_LEGS } from './actions';
export const legsReducer = handleActions({
    [SET_LEGS]: (state, action) => action.payload
}, []);
